let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aVmNA")).then(() => parcelRequire('flZwp'));